/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardAutotopup.scss';
import {
  appButtonType,
  appCardStyle,
  appChipSize,
  appChipStyle,
  appIconsPath,
  appLinkSize,
  appLinkStyle,
  getKeyByValue
} from '@utils/globalConstant';
import { Link } from '@core/Link';
import { Chip } from '@core/Chip';
import PropTypes from 'prop-types';
import { ButtonPrimary } from '@core/ButtonPrimary';
import Icons from '@core/Utils/Icons/Icons';
import { sanitizeRichText } from '@utils/sanitizeHtml';

export function CardAutotopup({
  cardStyle = appCardStyle.DEFAULT,
  cardIcon = null,
  chipStyle = appChipStyle.WHITE,
  chipIcon = null,
  chipLabel = '',
  cardTitle = '',
  text = '',
  redirectionLabel = '',
  redirectionIcon = appIconsPath.ARROW_RIGHT_SMALL,
  redirectionStyle = appLinkStyle.PRIMARY,
  handleRedirection = '#',
  buttonContent = '',
  buttonLabel = '',
  buttonType = appButtonType.SECONDARY,
  handleButtonClick = () => {},
  handleLinkClick = () => {}
}) {
  const cardTopUpIcon = getKeyByValue(appIconsPath,cardIcon);
  
  return (
    <div className={`${cardStyle} rounded-4 pt-24 px-20 pb-20`}>
      <div className="row">
        <div className="col-12 d-flex gap-20 align-items-center">
          {cardIcon && <Icons name={cardTopUpIcon} height={24} colorType='dark' className="link-icon pe-8" alt="card-icon" />}
          {chipIcon && chipLabel && (
            <Chip
              chipStyle={chipStyle}
              chipSize={appChipSize.LARGE}
              icon={chipIcon}
              label={chipLabel}
            />
          )}
        </div>
        {cardTitle && (
          <div
            className="ek-copy-16-semibold col-12 pt-20 text-white align-content-center"
            dangerouslySetInnerHTML={{ __html: sanitizeRichText(cardTitle) }}
          />
        )}
        {text && (
          <div
            className="ek-copy-sm-14-regular col-12 pt-20 align-content-center"
            dangerouslySetInnerHTML={{ __html: sanitizeRichText(text) }}
          />
        )}
        {(buttonContent || buttonLabel) && (
          <div className="col-12 pt-20">
            <ButtonPrimary
              buttonType={buttonType}
              buttonContent={buttonContent}
              label={buttonLabel}
              onClick={() => handleButtonClick()}
            />
          </div>
        )}
        {redirectionLabel && (
          <div className="col-12 pt-20">
            <Link
              label={redirectionLabel}
              iconRight={redirectionIcon}
              linkStyle={redirectionStyle}
              linkSize={appLinkSize.DEFAULT}
              linkRef={handleRedirection}
              onClick={handleLinkClick}
            />
          </div>
        )}
      </div>
    </div>
  );
}

CardAutotopup.propTypes = {
  cardStyle: PropTypes.string,
  cardIcon: PropTypes.string,
  chipStyle: PropTypes.string,
  chipIcon: PropTypes.string,
  chipLabel: PropTypes.string,
  cardTitle: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  redirectionLabel: PropTypes.string.isRequired,
  redirectionIcon: PropTypes.string,
  redirectionStyle: PropTypes.string,
  handleRedirection: PropTypes.func
};

export default CardAutotopup;
